export default (function (_ref) {
  var service = _ref.service,
      request = _ref.request,
      serviceForMock = _ref.serviceForMock,
      requestForMock = _ref.requestForMock,
      mock = _ref.mock,
      faker = _ref.faker,
      tools = _ref.tools;
  return {
    /**
     *  游戏
     */
    // 游戏列表
    configurationData: function configurationData() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/configuration/configurationData',
        method: 'get',
        data: data
      });
    },
    // 新增游戏
    configurationAdd: function configurationAdd() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/configuration/configurationAdd',
        method: 'post',
        data: data
      });
    },
    // 修改游戏
    configurationUpdate: function configurationUpdate() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/configuration/configurationUpdate',
        method: 'post',
        data: data
      });
    },
    // 删除游戏
    configurationDel: function configurationDel() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/configuration/configurationDel',
        method: 'post',
        data: data
      });
    },
    // 获取游戏
    configurationAll: function configurationAll() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/configuration/configurationAll',
        method: 'get',
        data: data
      });
    },
    // 游戏排序
    configurationChangeSort: function configurationChangeSort() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/configuration/configurationChangeSort',
        method: 'post',
        data: data
      });
    },
    // logo
    logoSetData: function logoSetData() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/configuration/logoSetData',
        method: 'get',
        data: data
      });
    },
    // logo修改
    logoSetUpdate: function logoSetUpdate() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/configuration/logoSetUpdate',
        method: 'post',
        data: data
      });
    },

    /**
     * 页脚
     */
    // 页脚列表
    copyrightData: function copyrightData() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/copyright/copyrightData',
        method: 'get',
        data: data
      });
    },
    // 新增页脚
    copyrightAdd: function copyrightAdd() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/copyright/copyrightAdd',
        method: 'post',
        data: data
      });
    },
    // 修改页脚
    copyrightUpdate: function copyrightUpdate() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/copyright/copyrightUpdate',
        method: 'post',
        data: data
      });
    },
    // 删除页脚
    copyrightDel: function copyrightDel() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/copyright/copyrightDel',
        method: 'post',
        data: data
      });
    },

    /**
     * 用户协议
     */
    // 用户协议列表
    userAgreementData: function userAgreementData() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/userAgreement/userAgreementData',
        method: 'get',
        data: data
      });
    },
    // 新增用户协议
    userAgreementAdd: function userAgreementAdd() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/userAgreement/userAgreementAdd',
        method: 'post',
        data: data
      });
    },
    // 修改用户协议
    userAgreementUpdate: function userAgreementUpdate() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/userAgreement/userAgreementUpdate',
        method: 'post',
        data: data
      });
    },
    // 删除用户协议
    userAgreementDel: function userAgreementDel() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/userAgreement/userAgreementDel',
        method: 'post',
        data: data
      });
    },

    /**
     * 隐私政策
     */
    // 隐私政策列表
    privacyAgreementData: function privacyAgreementData() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/privacyAgreement/privacyAgreementData',
        method: 'get',
        data: data
      });
    },
    // 新增隐私政策
    privacyAgreementAdd: function privacyAgreementAdd() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/privacyAgreement/privacyAgreementAdd',
        method: 'post',
        data: data
      });
    },
    // 修改隐私政策
    privacyAgreementUpdate: function privacyAgreementUpdate() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/privacyAgreement/privacyAgreementUpdate',
        method: 'post',
        data: data
      });
    },
    // 删除隐私政策
    privacyAgreementDel: function privacyAgreementDel() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/privacyAgreement/privacyAgreementDel',
        method: 'post',
        data: data
      });
    },

    /**
     * 联系我们
     */
    // 联系我们列表
    contactWayData: function contactWayData() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/contactWay/contactWayData',
        method: 'get',
        data: data
      });
    },
    // 新增联系我们
    contactWayAdd: function contactWayAdd() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/contactWay/contactWayAdd',
        method: 'post',
        data: data
      });
    },
    // 修改联系我们
    contactWayUpdate: function contactWayUpdate() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/contactWay/contactWayUpdate',
        method: 'post',
        data: data
      });
    },
    // 删除联系我们
    contactWayDel: function contactWayDel() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/contactWay/contactWayDel',
        method: 'post',
        data: data
      });
    },
    // 获取商品图片列表
    productPicList: function productPicList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/productPic/productPicList',
        method: 'get',
        data: data
      });
    },
    // 添加商品图片
    productPicAdd: function productPicAdd() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/productPic/productPicAdd',
        method: 'post',
        data: data
      });
    },
    // 删除商品图片
    productPicDel: function productPicDel() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/productPic/productPicDel',
        method: 'post',
        data: data
      });
    },
    // 批量上传商品
    productMassUpload: function productMassUpload() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/productPic/productMassUpload',
        method: 'post',
        data: data
      });
    },
    // 语言列表
    languageInfoData: function languageInfoData() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/languageInfo/languageInfoData',
        method: 'get',
        data: data
      });
    },
    // 语言新增
    languageInfoAdd: function languageInfoAdd() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/languageInfo/languageInfoAdd',
        method: 'post',
        data: data
      });
    },
    // 语言修改
    languageInfoUpdate: function languageInfoUpdate() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/languageInfo/languageInfoUpdate',
        method: 'post',
        data: data
      });
    },
    // 语言删除
    languageInfoDel: function languageInfoDel() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/languageInfo/languageInfoDel',
        method: 'post',
        data: data
      });
    },
    // 密码修改日志
    updateLogData: function updateLogData() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/updateLogData',
        method: 'get',
        data: data
      });
    },
    // 密码修改日志所有
    updateLogDataAll: function updateLogDataAll() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/updateLogDataAll',
        method: 'get',
        data: data
      });
    },
    // 邮箱验证码发送日志
    sendEmailLogData: function sendEmailLogData() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/sendEmailLogData',
        method: 'get',
        data: data
      });
    },
    // 邮箱验证码发送日志所有
    sendEmailLogDataAll: function sendEmailLogDataAll() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/sendEmailLogDataAll',
        method: 'get',
        data: data
      });
    },
    activityImgPopUpList: function activityImgPopUpList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/configuration/activityImgPopUpList',
        method: 'get',
        data: data
      });
    },
    activityImgPopUpAdd: function activityImgPopUpAdd() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/configuration/activityImgPopUpAdd',
        method: 'post',
        data: data
      });
    },
    activityImgPopUpUpdate: function activityImgPopUpUpdate() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/configuration/activityImgPopUpUpdate',
        method: 'post',
        data: data
      });
    },
    activityImgPopUpDel: function activityImgPopUpDel() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/configuration/activityImgPopUpDel',
        method: 'post',
        data: data
      });
    }
  };
});